export default __webpack_public_path__ + "static/media/fevrtoken-facing-right.ddd3f07b.png";